import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { JZAuthService } from './jz-auth.service';

@Injectable({
  providedIn: 'root'
})
export class  JZAuthGuard implements CanActivate {
  constructor(private router: Router,private oauthService: OAuthService, private jzAuthService: JZAuthService) {}
  canActivate() {
    if (!this.jzAuthService.enable){
      return true;
    }
    if (this.oauthService.hasValidAccessToken()) {
      return true;
    } else {
      let redirecturl=location.hash.replace('#',''); //获取不到当前地址暂时这样处理
      if(!redirecturl){
        redirecturl=location.href.replace(location.origin,'')||'/';
      }
      sessionStorage.setItem("redirecturl",redirecturl);
      this.router.navigate(['auth/login']);
      return false;
    }
  }
}
